// test2618
(2618 && 0);
